import QRCode from 'qrcode'

// 扫码分享页托管基址（Cloudflare Pages，直接上传部署）。
// 二维码内容 = 基址 + '#/<路由>?start=起始年月&end=终止年月&mask=脱敏字段'
const SHARE_BASE_URL = 'https://jsrs-records.pages.dev/'

// 允许运行时覆盖（调试/换托管地址时无需重新构建）：localStorage.setItem('shareBaseUrl', 'https://...')
export function getShareBaseUrl() {
  try {
    return localStorage.getItem('shareBaseUrl') || SHARE_BASE_URL
  } catch (e) {
    return SHARE_BASE_URL
  }
}

// 按起止年月、脱敏字段拼接扫码落地页 URL（hash 路由，纯静态可直接访问）
export function buildShareUrl(routePath, startDate, endDate, maskList) {
  const params = []
  if (startDate) params.push('start=' + encodeURIComponent(startDate))
  if (endDate) params.push('end=' + encodeURIComponent(endDate))
  if (maskList && maskList.length) params.push('mask=' + encodeURIComponent(maskList.join(',')))
  const query = params.length ? '?' + params.join('&') : ''
  return getShareBaseUrl() + '#' + routePath + query
}

// 生成二维码图片 dataURL（供 <img> 展示与 html2canvas 截图，天然可离线、可入图）
export async function generateQrDataUrl(text) {
  return await QRCode.toDataURL(text, {
    width: 360,
    margin: 1,
    errorCorrectionLevel: 'M',
    color: { dark: '#323233', light: '#ffffff' }
  })
}



// WEBPACK FOOTER //
// ./src/utils/share.js